// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1O5b9","range":"MonthRangeSwitch_range__3czaP","disabled":"MonthRangeSwitch_disabled__9vGbl"};